import React from "react";

/**
 * Low-contrast text link rendered under the Pay button when the
 * link's /info projection reports more than one payment method.
 * Toggles activeMethod between 'x402' and 'direct'.
 *
 * When only one method is available, this component renders
 * nothing — no need for a switcher with nowhere to switch to.
 */
export function MethodSwitcher({
  link,
  activeMethod,
  onSwitch,
}) {
  const methods = link?.paymentMethods || [];
  if (methods.length < 2) return null;

  const other = activeMethod === "x402" ? "direct" : "x402";
  if (!methods.includes(other)) return null;

  const label =
    other === "direct"
      ? "Pay with direct transfer instead →"
      : `Pay gasless with ${link.tokenSymbol} instead →`;

  return (
    <button
      type="button"
      className="pay-method-switcher"
      onClick={() => onSwitch(other)}
    >
      {label}
    </button>
  );
}
